import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

class Secctiontext extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].Secctiontext

    return (
      <div className="container-fluid">
        <section className="margin-top-50 row ">
          <div className="container">
            <div className="row">

              <div className="col-md-12">
                <h1 className="h3 heavy">{`${langPlace.title}`}</h1>
              </div>

            </div>
          </div>
        </section>

          <section className="wrapper-text-boxes row">
            <div className="container">

              <div className="row">
                <div className="col-md-8">
                <div className="background-image-big text-box left"></div>
                </div>
                <div className="col-md-4">
                  <div className="text-box right">
                    <p className="title heavy">{langPlace.tuno}</p>
                    <p className="light">{langPlace.puno}<Link to="http://www.romeuycia.com">Romeu y Cía</Link></p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="text-box left">
                    <p className="title heavy">{langPlace.tdos}</p>
                    <p className="light">{langPlace.pdos}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="background-image-middle text-box right"></div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="background-image-little text-box left"></div>
                </div>
                <div className="col-md-8">
                  <div className="text-box right">
                    <p className="title heavy">{langPlace.ttres}</p>
                    <p className="light">{langPlace.ptres}<Link to="http://www.gruporomeu.com/">Grupo Romeu</Link></p>
                  </div>
                </div>
              </div>
            </div>
          </section>

      </div>
    );
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(Secctiontext)



// WEBPACK FOOTER //
// ./src/shared/routes/routePageText/secctiontext.js